import React, { useState, useRef } from "react";
import { Button, Carousel, Divider, Steps } from "antd";
import { ResultsScore } from "../components/ResultsContent";
import ProgressBarCustom from "../components/Progress";
import { useWindowSize } from "../hooks/helpfulhooks";

import { updateUserInMailchimpBulk } from "../components/ResultsContent";
import { wheel as wheelInfo } from "../constants/settings";

function isComplete(surveyResults) {
  const emptySurveys = Object.keys(surveyResults).map((key) => {
    const isEmpty = Object.keys(surveyResults[key]).length === 0;
    return isEmpty ? key : null;
  });

  const leftOvers = emptySurveys?.filter((category) => category !== null);

  return leftOvers.length === 0;
}

export default function CardContent({
  currentCategory,
  surveyResults,
  setSurveyResults,
  setCategory,
  setCardContentView,
  userInfo,
  setUserInfo
}) {
  const { key: categoryKey, questions } = currentCategory;
  const carouselRef = useRef();
  const [currentStep, setStep] = useState(0);

  // Get window size information
  const windowSize = useWindowSize();
  const isSmallWindow = windowSize.width <= 480;

  // Controls stepping out of order on the carousel
  // NOTE: FIX OUT OF ORDER STEPPING TO TABLE!!!
  const handleChangeStep = (step) => {
    if (carouselRef && carouselRef.current) {
      setStep(step);
      carouselRef.current.goTo(step, false);
    }
  };

  // Add step components on the bottom
  const steps = Object.keys(questions).map((i) => <Steps.Step key={i} />);
  const answerCard = <Steps.Step key="answers" />;
  steps.push(answerCard);
  const isLastStep = currentStep === steps.length - 1;

  // Content view of the carousel
  const carouselCards = Object.keys(questions).map((i) => (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h2
        style={{
          textAlign: "center",
          fontSize: isSmallWindow ? "17px" : "20px"
        }}
        key={i}
      >
        {questions[i]}
      </h2>
    </div>
  ));

  // Add a Final Step to Show Results
  // This is an empty div as putting content here would
  //     cause the height of carousel to change
  carouselCards.push(<div></div>);

  // Complete the carousel
  const carousel = (
    <div
      style={{
        paddingLeft: "5%",
        paddingRight: "5%",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "25%",
        position: "relative"
      }}
    >
      <Carousel
        dots={false}
        ref={carouselRef}
        effect="scrollx"
        style={{ marginTop: "20px", position: "relative", maxHeight: "25vh" }}
      >
        {carouselCards}
      </Carousel>
    </div>
  );

  // ResultsScore and SignUp
  const resultsScoreAndSignUp = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "5%", 
        paddingTop: "15px", 
        paddingRight: "5%" 
      }}
    >
      <ResultsScore
        key="results"
        surveyResults={surveyResults}
        currentCategory={currentCategory}
        shouldShowSignup={userInfo.email === null}
        setUserInfo={setUserInfo}
      />
    </div>
  )

  // Top Progress Button Button
  const topButton = (
    <div
      style={{
        position: "relative"
      }}
    >
      <Button
        block
        disabled={userInfo.isSignedUp === false}
        type="primary"
        style={{
          borderRadius: "0px",
          backgroundColor: "rgb(130,170,145)",
          borderColor: "rgb(130,170,145)"
        }}
        onClick={() => {
          const emptySurveys = Object.keys(surveyResults).map((key) => {
            const isEmpty = Object.keys(surveyResults[key]).length === 0;
            return isEmpty ? key : null;
          });

          const leftOvers = emptySurveys?.filter(
            (category) => category !== null
          );

          const isComplete = leftOvers.length === 0;
          const nextCategory = wheelInfo[leftOvers[0]];

          updateUserInMailchimpBulk(
            {
              user: userInfo.id,
              results: surveyResults
            },
            "handlebulkupdate"
          ).then((result) => console.log("result is ", result));

          if (isComplete) {
            setCardContentView("results");
            setCategory(wheelInfo.default);
          } else {
            setCategory(nextCategory);
            setStep(0);
            carouselRef.current.goTo(0, false);
          }
        }}
      >
        {!isComplete(surveyResults)
          ? "Move on to Next Category"
          : "See Full Results"}
      </Button>
    </div>
  )

  // Top Category Progress Bar 
  const topCategoryProgressBar = (
    <div
      style={{ paddingLeft: "5%", paddingTop: "10px", paddingRight: "5%" }}
    >
      <ProgressBarCustom surveyResults={surveyResults} />
    </div>
  )

  // Yes No Question Buttons 
  const questionairYesNoButtons = (
    <div
      style={{
        zIndex: 2,
        // position: isSmallWindow ? "absolute" : "relative",
        display: "flex",
        width: "100vw",
        marginTop: "15px"
      }}
    >
      <Button
        style={{
          marginLeft: "20px",
          marginRight: "5px",
          backgroundColor: "Transparent",
          borderColor: "Black",
          color: "Black"
        }}
        block
        size="large"
        type="danger"
        onClick={() => {
          setSurveyResults((prev) => {
            const updated = { [currentStep]: -1 };
            prev[categoryKey] = { ...prev[categoryKey], ...updated };
            return prev;
          });
          carouselRef.current.goTo(currentStep + 1, false);
          setStep(currentStep + 1);
        }}
      >
        No
      </Button>
      <Button
        style={{
          marginRight: "20px",
          marginLeft: "5px",
          backgroundColor: "Transparent",
          borderColor: "Black",
          color: "Black"
        }}
        size="large"
        block
        type="primary"
        onClick={() => {
          setSurveyResults((prev) => {
            const updated = { [currentStep]: 1 };
            prev[categoryKey] = { ...prev[categoryKey], ...updated };
            return prev;
          });

          carouselRef.current.goTo(currentStep + 1, false);
          setStep(currentStep + 1);
        }}
      >
        Yes
      </Button>
    </div>
  )

  // BottomProgressBar for Steps
  const stepProgressBar = (
    <div
      style={{
        position: isSmallWindow ? "relative" : "absolute",
        bottom: 0,
        right: 0,
        left: 0
      }}
    >
      <Divider />
      <Steps
        type="navigation"
        size="small"
        labelPlacement={"horizontal"}
        current={currentStep}
        onChange={handleChangeStep}
      >
        {steps}
      </Steps>
    </div>
  )


  return (
    <div>
      {isLastStep === true ? topButton : null}
      {isLastStep === true ? topCategoryProgressBar : null}
      {isLastStep === true ? resultsScoreAndSignUp : null}
      {carousel}
      {isLastStep === false ? questionairYesNoButtons : null}
      {isLastStep === false ? stepProgressBar : null}
    </div>
  );
}
